import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";

export interface RadioOption {
  label: string;
  value: string | number;
}

interface RadioGroupProps {
  options: RadioOption[];
  value?: string | number | null;
  onChange: (value: string | number) => void;
  className?: string;
  /** 只读/禁用：保留选中态展示，不可点击切换 */
  disabled?: boolean;
}

/**
 * 通用单选组（图标 + 文字，横向排列，样式对齐预约项目 radio）。
 */
export default function RadioGroup(props: RadioGroupProps) {
  const { options, value, onChange, className = "", disabled = false } = props;
  return (
    <div className={classNames(styles.group, className)}>
      {options.map((opt) => (
        <div
          key={String(opt.value)}
          className={styles.option}
          onClick={disabled ? undefined : () => onChange(opt.value)}
        >
          <i
            className={classNames(styles.icon, {
              [styles.checked]: value === opt.value,
            })}
          />
          <span className={styles.text}>{opt.label}</span>
        </div>
      ))}
    </div>
  );
}
